import { Dispatch } from "redux";
import { captureException } from "@sentry/react";
import { AxiosInstance } from "axios";
import { showNotification } from "../../notification/actions";

import { GET_PLAN_META } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";
import { IMeta, IPlan } from "../../../../common/types";

export default () => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    let planId = (getState().plan as IPlan)._id;
    try {
        const res = await api.get<IMeta>(`/plan-meta?planId=${planId}`);
        dispatch({
            type: GET_PLAN_META,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};